import React from 'react'
import Button from '@boltui/button'
import { ArgosTheme } from '@boltui/themes'
import * as Styled from '../../Footer.styles'

import {
  customerServiceLinks,
  paymentMethodLinks,
  aftercareLinks,
  productInfolinks,
  otherSitesLinks,
  primaryButtons,
  aboutLinks
} from '../FooterUrls'

const OverwrittenTheme = {
  ...ArgosTheme,
  color_secondary: ArgosTheme.color_grey_darker,
  color_secondary_dark: ArgosTheme.color_grey_darker
}

const primaryLinks = (type) =>
  type.map((link) => (
    <li key={link.text}>
      <Styled.PrimaryLink href={link.href} data-test={link['data-test']}>
        {link.text}
      </Styled.PrimaryLink>
    </li>
  ))

const PrimaryFooter = () => (
  <Styled.Primary>
    <div className='container container--row'>
      <div className='md-row xs-12--negative xs-hidden'>
        <div className='md-3'>
          <Styled.PrimaryTitle data-test='customer-service'>Customer Service</Styled.PrimaryTitle>
          <ul>{primaryLinks(customerServiceLinks)}</ul>
        </div>
        <div className='md-3'>
          <Styled.PrimaryTitle data-test='payment-methods'>Payment methods</Styled.PrimaryTitle>
          <ul>{primaryLinks(paymentMethodLinks)}</ul>
          <Styled.PrimaryTitle data-test='aftercare'>Aftercare</Styled.PrimaryTitle>
          <ul>{primaryLinks(aftercareLinks)}</ul>
        </div>
        <div className='md-3'>
          <Styled.PrimaryTitle data-test='product-information'>Product information</Styled.PrimaryTitle>
          <ul>{primaryLinks(productInfolinks)}</ul>
          <Styled.PrimaryTitle data-test='other-argos-sites'>Other Argos sites</Styled.PrimaryTitle>
          <ul>{primaryLinks(otherSitesLinks)}</ul>
        </div>
        <div className='md-3'>
          <Styled.PrimaryTitle>About Argos</Styled.PrimaryTitle>
          <ul>{primaryLinks(aboutLinks)}</ul>
        </div>
      </div>

      <div className='xs-row xs-12--none md-hidden'>
        {primaryButtons.map((button) => (
          <div className='xs-6' key={button.text}>
            <Button
              full
              as='a'
              href={button.href}
              aria-label={button.text}
              theme={OverwrittenTheme}
              data-test={button['data-test']}
              style={{ marginBottom: 15 }}>
              {button.text}
            </Button>
          </div>
        ))}
      </div>
    </div>
  </Styled.Primary>
)

export default PrimaryFooter
